import React,{ useEffect } from 'react';
import { data, urlRoot} from '../utils/data';
import {useStateContext} from '../context/stateContext';



const Landing = () => {
  const {lightTheme, setLinkHovred, setIsNotProject} = useStateContext();

  // this means im not in project section
  useEffect(()=>{
    setIsNotProject(true);
  },[])

  return (
    <section className={`landing ${lightTheme ? "light" : "dark"}`} id="home">
      <div className="container">
        <h1 style={{ color: `${lightTheme ? "#393E46" : "#FCFFE7"}` }}>
          Hi There 👋,
          <br />
          I'm{" "}
          <a
            href="#about"
            onMouseLeave={() => setLinkHovred(false)}
            onMouseEnter={() => setLinkHovred(true)}
          >
            {data?.firstName}
          </a>
          ,<br />
          {data?.job}
        </h1>
        <a
          href="#skills"
          onMouseLeave={() => setLinkHovred(false)}
          onMouseEnter={() => setLinkHovred(true)}
        >
          <div className="landing-images">
            <img src={`${urlRoot}/assets/home-1.png`} alt="landing-image-1" />
            <img src={`${urlRoot}/assets/home-2.png`} alt="landing-image-2" />
            <img src={`${urlRoot}/assets/home-3.png`} alt="landing-image-3" />
            <img src={`${urlRoot}/assets/home-4.png`} alt="landing-image-4" />
          </div>
        </a>
      </div>
    </section>
  );
}

export default Landing
